export const __ =  '@@__function/placeholder__@@';




// WEBPACK FOOTER //
// ./src/symbols.ts